import exploreEvents from '@/utils/gaEvents/exploreEvents'

import type { ParkinglotDetail, SharedParkinglotDetail } from '@/api/server/detail/dto/detailDto'
import Icons from '@/shared/components/icon/Icons'
import { Caption } from '@/shared/components/typography'

import { PARKINGLOT_TYPE } from '@/enums/detail'
import { CATE_CATEGORY } from '@/enums/gtagEvents'

interface SummaryFunctionSectionViewProps {
  pin: ParkinglotDetail | SharedParkinglotDetail
  setIsRoadViewOpen: React.Dispatch<React.SetStateAction<boolean>>
  setIsNavigationOpen: React.Dispatch<React.SetStateAction<boolean>>
  setIsShareOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const SummaryFunctionSectionView = ({
  pin,
  setIsShareOpen,
  setIsNavigationOpen,
  setIsRoadViewOpen
}: SummaryFunctionSectionViewProps) => {
  const pinCategory = () => {
    if (pin.type === PARKINGLOT_TYPE.SHARE) {
      return CATE_CATEGORY.SHARE
    } else {
      return pin.basic.partnerStatus ? CATE_CATEGORY.PARTNER : CATE_CATEGORY.NORMAL
    }
  }

  return (
    <div className="flex h-[55px] items-center">
      <div className="flex w-full justify-evenly">
        <div
          className="flex flex-1 cursor-pointer items-center justify-center"
          onClick={() => {
            if (pin.type === PARKINGLOT_TYPE.SHARE) {
              exploreEvents.shared.onClickShareButton(pin.seq)
            } else {
              exploreEvents.partner.onClickShareButton(pinCategory(), pin.seq)
            }
            setIsShareOpen(true)
          }}
        >
          <div className="h-[18px] w-[18px]">
            <Icons.SharePIcon stroke="currentColor" color="#263238" />
          </div>
          <Caption level="caption1" weight="regular" color="text090" className="ml-[8px]">
            공유
          </Caption>
        </div>
        <div
          className="flex flex-1 cursor-pointer items-center justify-center border-x-[1px] border-020"
          onClick={() => {
            if (pin.type === PARKINGLOT_TYPE.SHARE) {
              exploreEvents.shared.onClickRoadViewButton(pin.seq)
            } else {
              exploreEvents.partner.onClickRoadViewButton(pinCategory(), pin.seq)
            }
            setIsRoadViewOpen(true)
          }}
        >
          <div className="h-[18px] w-[18px]">
            <Icons.RoadViewIcon stroke="currentColor" color="#263238" />
          </div>
          <Caption level="caption1" weight="regular" color="text090" className="ml-[8px]">
            로드뷰
          </Caption>
        </div>
        <div
          className="flex flex-1 cursor-pointer items-center justify-center"
          onClick={() => {
            if (pin.type === PARKINGLOT_TYPE.SHARE) {
              exploreEvents.shared.onClickNaviButtonInExplore(pin.seq)
            } else {
              exploreEvents.partner.onClickNaviButtonInExplore(pinCategory(), pin.seq)
            }
            setIsNavigationOpen(true)
          }}
        >
          <div className="h-[18px] w-[18px]">
            <Icons.NaviIconStroke color="#263238" />
          </div>
          <Caption level="caption1" weight="regular" color="text090" className="ml-[8px]">
            내비
          </Caption>
        </div>
      </div>
    </div>
  )
}

export default SummaryFunctionSectionView
